<template>
	<Toast
		position="top-center"
		group="headless"
		class="global-toast">
		<template #container="{ message }">
			<div
				class="toast__container"
				:class="`toast__container--${message.severity}`">
				<GlobalIcon
					:name="`toast-${message.severity ?? 'error'}`"
					height="16"
					class="toast__icon"
					default />
				<div class="toast__message">{{ message.summary }}</div>
			</div>
		</template>
	</Toast>
</template>

<script lang="ts" setup>
import Toast from 'primevue/toast'
</script>

<style lang="scss">
@import './Toast.scss';
</style>
